export default __webpack_public_path__ + "static/media/IconSecurity.f8525870.png";